import { IconSelector, IconChevronDown, IconChevronUp } from "@tabler/icons";
import {
  createStyles,
  UnstyledButton,
  Group,
  Text,
  Center,
} from "@mantine/core";
// import { LegalForm } from "src/sections/Table/TableJuries";

// interface RowData {
//   name: string;
//   address: string;
//   creationYear: number;
//   activity: string;
//   legalForm: LegalForm;
// }

interface ThProps {
  children: React.ReactNode;
  reversed: boolean;
  sorted: boolean;
  onSort(): void;
}

function filterData<T extends object[]>(data: T, search: string): T {
  const query = search.toLowerCase().trim();
  const response = data.filter((item) => {
    return Object.keys(item).some((key) => {
      if (typeof item[key] === "string") {
        return item[key].toLowerCase().includes(query);
      } else if (typeof item[key].toString === "function") {
        return item[key].toString().toLowerCase().includes(query);
      }
      return false;
    });
  });
  return response as T;
}

export function sortData<T extends object[]>(
  data: T,
  payload: { sortBy: keyof T[number] | null; reversed: boolean; search: string }
) {
  const { sortBy } = payload;
  if (!sortBy) {
    return filterData(data, payload.search);
  }
  return filterData(
    [...data].sort((a, b) => {
      // if (sortBy === "legalForm") {
      //   const _a = a[sortBy].name.toString();
      //   const _b = b[sortBy].name.toString();
      //   if (payload.reversed) return _b.localeCompare(_a);
      //   return _a.localeCompare(_b);
      // } else {
      if (typeof a[sortBy] === "number") {
        const _a = a[sortBy] as number,
          _b = (b?.[sortBy] || 0) as number;
        if (payload.reversed) return _b - _a;
        return _a - _b;
      }
      const _a = (a[sortBy] || "").toString();
      const _b = (b[sortBy] || "").toString();
      if (payload.reversed) return _b.localeCompare(_a);
      return _a.localeCompare(_b);
      // }
    }),
    payload.search
  );
}

const useStyles = createStyles((theme) => ({
  th: {
    padding: "0 !important",
  },

  control: {
    width: "100%",
    padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  icon: {
    width: 21,
    height: 21,
    borderRadius: 21,
  },
}));

export function Th({ children, reversed, sorted, onSort }: ThProps) {
  const { classes } = useStyles();
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;
  return (
    <th className={classes.th}>
      <UnstyledButton onClick={onSort} className={classes.control}>
        <Group position="apart">
          <Text weight={500} size="sm">
            {children}
          </Text>
          <Center className={classes.icon}>
            <Icon size={14} stroke={1.5} />
          </Center>
        </Group>
      </UnstyledButton>
    </th>
  );
}
